module.exports = __webpack_public_path__ + "img/2.9ec200a8.webp";